import { t } from '@lingui/macro'
import { useState } from 'react'

import { ErrorLayout } from '@/modules/shared/components/error-layout/ErrorLayout'
import { AnimatedLoader } from '@/modules/shared/components/loader/Loader'
import errorConnectionSvg from './error-connection.svg?raw'

// Bundled inline: this page is shown while offline, so a separately fetched
// image would never load.
const errorConnectionImgSrc = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(errorConnectionSvg)}`

type Props = {
  onRetry: () => void
}

const NoConnectionPage = ({ onRetry }: Props) => {
  const [isLoading, setIsLoading] = useState(false)

  // Interaction Methods
  // ------------------------------------------------------------------------- /
  function refreshPage() {
    setIsLoading(true)
    setTimeout(() => {
      setIsLoading(false)
      onRetry()
    }, 1000)
  }

  return isLoading ? (
    <AnimatedLoader cancellable />
  ) : (
    <ErrorLayout
      title={t({
        id: 'globals.connection-error.title',
        message: 'Verbinding even zoek',
      })}
      message={t({
        id: 'globals.connection-error.text',
        message:
          'Het lijkt erop dat je internetverbinding weggevallen is. Kijk je instellingen na en probeer dan nog een keer.',
      })}
      imgSrc={errorConnectionImgSrc}
      cta={{
        label: t({
          id: 'globals.connection-error.cta',
          message: 'Laad de pagina opnieuw',
        }),
        onClick: refreshPage,
      }}
    />
  )
}

export { NoConnectionPage }
